import { Rect, Text, Group } from 'react-konva';
import { COLORS } from '../../../../Core/Services/CanvasLayoutService';

const FILL_MAP = {
  floor: COLORS.floor.fill,
  stair: COLORS.stair.fill,
  entrance: COLORS.entrance.fill,
  empty: COLORS.empty.fill,
  containerNoRooms: COLORS.containerNoRooms.fill,
  containerBg: 'transparent',
};

const STROKE_MAP = {
  floor: COLORS.floor.stroke,
  stair: COLORS.stair.stroke,
  entrance: COLORS.entrance.stroke,
  empty: COLORS.empty.stroke,
  containerNoRooms: COLORS.containerNoRooms.stroke,
  containerBg: 'transparent',
};

const TEXT_COLOR_MAP = {
  stair: COLORS.stair.text,
  entrance: COLORS.entrance.text,
};

export default function CellRect({ x, y, width, height, type, label }) {
  const fill = FILL_MAP[type] || '#f5f5f5';
  const stroke = STROKE_MAP[type] || '#d1d5db';
  const strokeWidth =
    type === 'empty' || type === 'containerBg' || type === 'floor' ? 0 : 1;

  return (
    <Group x={x} y={y} listening={false}>
      <Rect
        width={width}
        height={height}
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
        cornerRadius={0}
      />
      {label && (
        <Text
          text={label}
          width={width}
          height={height}
          align="center"
          verticalAlign="middle"
          fontSize={Math.min(12, width * 0.25)}
          fill={TEXT_COLOR_MAP[type] || '#666'}
          fontStyle="bold"
        />
      )}
    </Group>
  );
}
